export const TRACER_STATUS_CODE = {
    UNSET: 'UNSET',
    OK: 'OK',
    ERROR: 'ERROR',
};
